// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"LoginHeader_navHeader__30-Sr","title":"LoginHeader_title__C05Ht","description":"LoginHeader_description__1Piqf","schoolName":"LoginHeader_schoolName__3vafr"};